import React, { useEffect } from 'react';
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';
import EventsList from '../EventsList';

interface IStateProps {
  id: number,
  events: any[],
  authToken: string,
}

interface IDispatchProps {
  fetchEvents: (token: string) => void,
  appendEvent: (event: any) => void,
}

type Props = IStateProps & IDispatchProps

const Events: React.FunctionComponent<Props> = ({ id, events, authToken, fetchEvents, appendEvent }) => {
  useEffect(() => {
    fetchEvents(authToken);
    subscribeListener('widgets:events:global', id, ({ data }) => {
      appendEvent(data);
    });
    return () => unsubscribeListener('widgets:events:global', id);
  }, [id, authToken, appendEvent, fetchEvents]);

  return <EventsList events={events} />;
};

export default Events;
